import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { slackApi } from '@/lib/api';

export function useSlackStatus() {
  return useQuery({
    queryKey: ['slack-status'],
    queryFn: () => slackApi.getStatus(),
  });
}

export function useSlackConnect() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: { botToken: string; signingSecret: string; channelId: string }) =>
      slackApi.connect(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['slack-status'] });
    },
  });
}

export function useSlackDisconnect() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => slackApi.disconnect(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['slack-status'] });
    },
  });
}

export function useSlackTest() {
  return useMutation({
    mutationFn: async () => {
      const result = await slackApi.test();
      if (!result.ok) {
        throw new Error('Failed to send test message. Make sure the bot is invited to the channel.');
      }
      return result;
    },
  });
}

export function useSlackChannels(enabled: boolean, botToken?: string) {
  return useQuery({
    queryKey: ['slack-channels', botToken],
    queryFn: () => slackApi.listChannels(botToken),
    enabled,
  });
}

export function useSlackChangeChannel() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (channelId: string) => slackApi.changeChannel(channelId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['slack-status'] });
    },
  });
}
